import React from "react";
import { AccessTime } from "@material-ui/icons";
import {
  AcUnit,
  AddLink,
  Adjust,
  AirlineSeatIndividualSuite,
  AlarmAdd,
  Badge,
  HolidayVillage,
  MilitaryTech,
  People,
  PersonAdd,
  PersonRemove,
  Schedule,
  Update,
  WatchLater,
  Weekend,
} from "@mui/icons-material";

export const workingHoursHeader = [
  { key: "date", name: "Date" },
  { key: "shift", name: "Shift" },
  { key: "check_in", name: "Check-In" },
  { key: "check_out", name: "Check-Out" },
  { key: "break", name: "Break" },
  { key: "shift_hours", name: "Shift Hours" },
  { key: "over_time", name: "Over Time Hours" },
  { key: "working_hours", name: "Total Working hours" },
  { key: "leave_credit_hours", name: "Leave Credit Hours" },
  { key: "status", name: "Status" },
];

export const firstLevelWorkingHours = [
  { header: "Employee Name", key: "employee_name" },
  { header: "Employee Id", key: "employee_id" },
  { header: "Department", key: "department_name" },
  { header: "Assigned Shift", key: "assigned_shift" },
  { header: "Week Off", key: "week_off_count" },
  { header: "Holiday", key: "holiday_count" },
  { header: "Leave", key: "leave_count" },
  { header: "Absent", key: "absent_count" },
  { header: "Present", key: "present_count" },
  { header: "Permission", key: "no_of_permission" },
  { header: "Late", key: "no_of_late" },
  { header: "Total Working Hours", key: "total_working_hours" },
  { header: "Shift Working Hours", key: "shift_working_hours" },
  { header: "Over Time Hours", key: "ot_hours" },
  { header: "Total Break Hours", key: "total_break_hours" },
];

export const workingHoursHeaders = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <AcUnit fontSize="small" />,
  },
  {
    name: "Department",
    key: "department_name",
    type: "autocomplete",
    icon: <People fontSize="small" />,
  },
  {
    name: "Assigned Shift",
    key: "assigned_shift",
    type: "number",
    icon: <MilitaryTech fontSize="small" />,
  },
  {
    name: "Week Off",
    key: "week_off_count",
    type: "number",
    icon: <Weekend fontSize="small" />,
  },
  {
    name: "Holiday",
    key: "holiday_count",
    type: "number",
    icon: <HolidayVillage fontSize="small" />,
  },
  {
    name: "Leave",
    key: "leave_count",
    type: "number",
    icon: <Adjust fontSize="small" />,
  },
  {
    name: "Absent",
    key: "absent_count",
    type: "number",
    icon: <PersonRemove fontSize="small" />,
  },
  {
    name: "Present",
    key: "present_count",
    type: "number",
    icon: <PersonAdd fontSize="small" />,
  },
  {
    name: "Permission",
    key: "no_of_permission",
    type: "number",
    icon: <AirlineSeatIndividualSuite fontSize="small" />,
  },
  {
    name: "Late",
    key: "no_of_late",
    type: "number",
    icon: <WatchLater fontSize="small" />,
  },
  {
    name: "Total Working Hours",
    key: "total_working_hours",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "Shift Working Hours",
    key: "shift_working_hours",
    type: "time",
    icon: <Schedule fontSize="small" />,
  },
  {
    name: "Over Time Hours",
    key: "ot_hours",
    type: "time",
    icon: <AlarmAdd fontSize="small" />,
  },
  {
    name: "Total Break Hours",
    key: "total_break_hours",
    type: "time",
    icon: <Update fontSize="small" />,
  },
];

export const punchDetailsHeader = [
  {
    name: "Employee Name",
    key: "username",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "Department Name",
    key: "department_name",
    type: "autocomplete",
    icon: <People fontSize="small" />,
  },
  {
    name: "Punch Count",
    key: "punch_in_count",
    type: "number",
    icon: <AddLink fontSize="small" />,
  },
];

export const timeCardReportHeaders = [
  {
    name: "Attendance Date",
    key: "attendance_date",
    type: "date",
    icon: <Schedule fontSize="small" />,
  },
  {
    name: "IN Time",
    key: "in_time",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "OUT Time",
    key: "out_time",
    type: "time",
    icon: <WatchLater fontSize="small" />,
  },
  {
    name: "Total Hrs",
    key: "total_hours",
    type: "time",
    icon: <Update fontSize="small" />,
  },
  {
    name: "Status",
    key: "status_display",
    type: "autocomplete",
    icon: <Adjust fontSize="small" />,
  },
];

export const timeLineHeader = [
  {
    name: "Name",
    key: "user",
    type: "string",
    icon: <People fontSize="small" />,
  },
  {
    name: "Department Name",
    key: "employee_id",
    type: "department",
    icon: <AccessTime fontSize="small" />,
  },
];
